import { Box, TableCell, TableRow } from '@mui/material';
import MediumTypography from '../../components/formlib/MediumTypography';
import { FC } from 'react';
import { ReactComponent as AcceptIcon } from '../../assets/images/acceptIcon.svg';
import { ReactComponent as RejectIcon } from '../../assets/images/rejectIcon.svg';
import ActionToolTip from '../../components/formlib/ActionToolTip';
import { checkPermissionForFeature } from '../../utils/checkPermission';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';

interface EmployeeListData {
  employeeId: string;
  employeeName: string;
  dateOfSubmission: string;
  totalAmount: string;
  status: string;
  travelId: string;
  expenseDate: string;
  milesAmt: string;
  travelMileageAmt: string;
  officeSuppliesAmt: string;
  fazzioDirectCareSuppliesAmt: string;
  duesAndSubscriptionAmt: string;
  postageAmt: string;
  printingOrDuplicatingAmt: string;
  continuingEdAmt: string;
  telephoneAmt: string;
  fazzioAmt: string;
  stipendAmt: string;
    otherAmt: string;
  isSelected: boolean;
  meterParkingTollsNaAmt:string
}

interface EmployeeProps {
  data: EmployeeListData;
  index: number;
  showSubmitButton?: boolean;
  onViewClick: () => void;
  onSelectTravelExpense: () => void;
  onRejectTravelExpense: () => void;
  onApproveTravelExpense: () => void;
}

const ReviewTravelExpenseEmployeeTable: FC<EmployeeProps> = ({
  data,
  index,
  showSubmitButton,
  onViewClick,
  onSelectTravelExpense,
  onRejectTravelExpense,
  onApproveTravelExpense,
}) => {
  let textColor = '#EB5757';

  if (data.status === 'Approved') {
    textColor = '#37D183';
  } else if (data.status === 'Pending') {
    textColor = '#F9B803';
  }

  return (
    <TableRow
      hover
      tabIndex={-1}
      sx={{
        cursor: 'pointer',
        backgroundColor: index % 2 === 0 ? '#ECF9F8' : '#ffffff',
      }}
    >
      {!showSubmitButton && (
        <TableCell
          sx={{
            position: 'sticky',
            left: 0,
            background: index % 2 === 0 ? '#ECF9F8' : '#ffffff',
          }}
        >
          <CheckBoxComponent
            disabled={
              !checkPermissionForFeature(
                'backend.review_travel_expense',
                'editPermission',
              )
            }
            ischecked={data.isSelected}
            CheckHandleChange={() => {
              onSelectTravelExpense();
            }}
          />
        </TableCell>
      )}
      <TableCell
        sx={{
          position: 'sticky',
          left: showSubmitButton ? 0 : '40px',
          background: index % 2 === 0 ? '#ECF9F8' : '#ffffff',
        }}
      >
        <MediumTypography
          className="cursor__pointer"
          onClick={onViewClick}
          sxProps={{ width: 'max-content' }}
          textColor="#008C82"
          label={
            data.employeeName !== '' || data.employeeName !== null
              ? data.employeeName
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.travelMileageAmt !== '' || data.travelMileageAmt !== null
              ? data.travelMileageAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.continuingEdAmt !== '' || data.continuingEdAmt !== null
              ? data.continuingEdAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.officeSuppliesAmt !== '' || data.officeSuppliesAmt !== null
              ? data.officeSuppliesAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.postageAmt !== '' || data.postageAmt !== null
              ? data.postageAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.printingOrDuplicatingAmt !== '' ||
            data.printingOrDuplicatingAmt !== null
              ? data.printingOrDuplicatingAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.telephoneAmt !== '' || data.telephoneAmt !== null
              ? data.telephoneAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.duesAndSubscriptionAmt !== '' ||
            data.duesAndSubscriptionAmt !== null
              ? data.duesAndSubscriptionAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.fazzioDirectCareSuppliesAmt !== '' ||
            data.fazzioDirectCareSuppliesAmt !== null
              ? data.fazzioDirectCareSuppliesAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.fazzioAmt !== '' || data.fazzioAmt !== null
              ? data.fazzioAmt
              : '-'
          }
        />
      </TableCell>
      {/* {/* <TableCell>
        <MediumTypography
          label={
            data.fazzioMileageAmt !== '' || data.fazzioMileageAmt !== null
              ? data.fazzioMileageAmt
              : '-'
          }
        />
      </TableCell> */}
      <TableCell>
        <MediumTypography
          label={
            data.meterParkingTollsNaAmt !== '' || data.meterParkingTollsNaAmt !== null
              ? data.meterParkingTollsNaAmt
              : '-'
          }
        />
      </TableCell> 
      <TableCell>
        <MediumTypography
          label={
            data.stipendAmt !== '' || data.stipendAmt !== null
              ? data.stipendAmt
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.otherAmt !== '' || data.otherAmt !== null
              ? `${data.otherAmt}`
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={
            data.totalAmount !== '' || data.totalAmount !== null
              ? `$${data.totalAmount}`
              : '-'
          }
        />
      </TableCell>
      <TableCell>
        <MediumTypography
          label={data.status !== '' || data.status !== null ? data.status : '-'}
          textColor={textColor}
        />
      </TableCell>
      {!showSubmitButton && (
        <TableCell>
          <Box className="flex__ btn_width_90px" gap={1.5}>
            <ActionToolTip labelId="approve" defaultLabel="Approve">
              <AcceptIcon
                onClick={() => {
                  if (
                    checkPermissionForFeature(
                      'backend.review_travel_expense',
                      'editPermission',
                    )
                  ) {
                    onApproveTravelExpense();
                  }
                }}
                className={
                  checkPermissionForFeature(
                    'backend.review_travel_expense',
                    'editPermission',
                  )
                    ? 'cursor__pointer'
                    : 'cursor__disabled'
                }
              />
            </ActionToolTip>
            <ActionToolTip labelId="reject" defaultLabel="Reject">
              <RejectIcon
                onClick={() => {
                  if (
                    checkPermissionForFeature(
                      'backend.review_travel_expense',
                      'editPermission',
                    )
                  ) {
                    onRejectTravelExpense();
                  }
                }}
                className={
                  checkPermissionForFeature(
                    'backend.review_travel_expense',
                    'editPermission',
                  )
                    ? 'cursor__pointer'
                    : 'cursor__disabled'
                }
              />
            </ActionToolTip>
          </Box>
        </TableCell>
      )}
    </TableRow>
  );
};
export default ReviewTravelExpenseEmployeeTable;
